module.exports = __webpack_public_path__ + "img/style_5_pl.7ebebc94.jpeg";